import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// Obtener documentos
export const getCustomerDocuments = async (id_Cliente) => {
  const token = localStorage.getItem("token");

  try {
    const res = await axios.get(
      `${API_URL}/api/documentosClientes/${id_Cliente}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return res.data;
  } catch (e) {
    console.error("❌ Error obteniendo documentos de cliente:", e);
    return [];
  }
};

// Subir documento
export const uploadCustomerDocument = async (
  file,
  id_Cliente,
  TipoDocumento,
  FechaCaducidad,
  nombreDocumento,
  temporada
) => {
  const token = localStorage.getItem("token");
  const formData = new FormData();

  const nameToSend = (nombreDocumento && String(nombreDocumento).trim()) || file?.name || "";
  formData.append("id_Cliente", id_Cliente);
  formData.append("TipoDocumento", TipoDocumento);
  formData.append("FechaCaducidad", FechaCaducidad);
  formData.append("nombreDocumento", nameToSend);
  if (temporada) {
    formData.append("Temporada", temporada);
  }
  formData.append("file", file);

  return axios.post(`${API_URL}/api/documentosClientes/upload`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "X-Document-Name": nameToSend,
    },
  });
};

// Actualizar nombre del documento
export const updateCustomerDocumentName = async (id_Documento, nombreDocumento) => {
  const token = localStorage.getItem("token");
  return axios.put(
    `${API_URL}/api/documentosClientes/${id_Documento}`,
    { nombreDocumento },
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

// Obtener Blob autenticado (para preview in-browser)
export const fetchCustomerDocumentBlob = async (id_Documento) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${API_URL}/api/documentosClientes/${id_Documento}/download`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    }
  );
  return response.data;
};

// Descargar documento con el nombre original
export const downloadCustomerDocument = async (id_Documento, downloadName) => {
  const blob = await fetchCustomerDocumentBlob(id_Documento);
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", downloadName || "documento");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// Eliminar documento
export const deleteCustomerDocument = async (id_Documento) => {
  const token = localStorage.getItem("token");

  return axios.delete(`${API_URL}/api/documentosClientes/${id_Documento}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
